<template><div><h1 id="personenmerkmal" tabindex="-1"><a class="header-anchor" href="#personenmerkmal"><span>Personenmerkmal</span></a></h1>
<p>Personenmerkmal — Stammtabelle</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Ansicht werden die Personenmerkmale definiert. Für Werttyp &quot;Auswahlliste&quot; müssen Vorgabewerte definiert werden, die bei der Verwendung des Merkmals ausgewählt werden können.</p>
<p>In der Ansicht Sprachversionen können die Versionen für verschiedene Sprachen definiert werden. Diese werden momentan (Stand 2018) nur bei der Funktion bei Person verwendet. Z.B. Direktor (deutsch), Directeur (französisch). Sprachversionen können nur für Werttyp &quot;Text&quot; erfasst werden.</p>
<p>Das Register &quot;Personen zu Merkmale&quot; listet die Personen auf die aktuell das selektierte Merkmal definiert haben und das Register &quot;Personen zu Vorgabewerte&quot; listet die Personen auf welche aktuell diesen Vorgabewert zugeordnet haben.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Merkmale Personen</code></p>
<h2 id="datenfelder-merkmale" tabindex="-1"><a class="header-anchor" href="#datenfelder-merkmale"><span>Datenfelder (Merkmale)</span></a></h2>
<dl>
<dt>Merkmal</dt>
<dd>Bezeichnung des Merkmals.</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Merkmals.</dd>
<dt>Werttyp</dt>
<dd>Definiert wie die Wertangabe beim erfassen eines Merkmals zu einer Person erfolgt. Es kann zwischen folgenden Typen ausgewählt werden:
<table>
<thead>
<tr>
<th>Werttyp</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ohne Wert</td>
<td>Merkmal ohne Wert, Wertzuweisung nicht möglich.</td>
</tr>
<tr>
<td>Text</td>
<td>Eingabe eines Textes als Wert.</td>
</tr>
<tr>
<td>Auswahlliste</td>
<td>Eine Auswahl von bereits definierten Werten (Vorgabewerte), z.B. vordefinierte Branchen. Siehe Merkmal-Auswahlliste/Vorgabewerte.</td>
</tr>
<tr>
<td>Datum</td>
<td>Eingabe eines Datums als Wert, z.B. 03.02.2004</td>
</tr>
<tr>
<td>Knoten</td>
<td>Eingabe eines Knotens als Wert, z.B. Branche.Dienstleistungen</td>
</tr>
<tr>
<td>numerisch, ganzzahlig</td>
<td>ganze Zahlen, z.B. 50</td>
</tr>
<tr>
<td>numerisch, dezimal</td>
<td>dezimale Zahlen, z.B. 275.25</td>
</tr>
</tbody>
</table>
</dd>
<dt>Mehrfach</dt>
<dd>Mehrfache Erfassung desselben Merkmals, ja/nein</dd>
<dt>Attribute</dt>
<dd>Zu einem Merkmal können mehrere Attribute zugewiesen werden. Für die Attribute existiert keine separate Tabelle, resp. können direkt beim Merkmal erfasst bzw. editiert werden. Ein Attribut kann dazu verwendet werden, um als Schlüssel zu dienen, z.B. Attribut &quot;Eloqua&quot; für den Abgleich aller Personen mit einem externen System beispielsweise Eloqua. In diesem Fall werden nur Personen abgeglichen die das Merkmal &quot;Eloqua&quot; zugeordnet haben.</dd>
<dt>aktiv bis</dt>
<dd>Definiert bis wann das Merkmal aktiv ist. Nach diesem Zeitpunkt kann das Merkmal nicht mehr einer Person zugeordnet werden, die bereits zugeordneten Merkmale behalten ihre Gültigkeit.</dd>
<dt>Anzahl</dt>
<dd>Anzahl der Adressen im System, die mit diesem Merkmal versehen sind<br>Die Anzahl wird im allgemeinen automatisch nachgeführt. Ein spezieller Zähllauf existiert ebenfalls in <a class="xref" href="Systemorganisation.html#sys-adressmerkmale-korrigieren" title="7.8.7. Personenmerkmale korrigieren">Abschnitt 7.8.7, „Personenmerkmale korrigieren “</a>.</dd>
</dl>
<h2 id="datenfelder-vorgabewerte" tabindex="-1"><a class="header-anchor" href="#datenfelder-vorgabewerte"><span>Datenfelder (Vorgabewerte)</span></a></h2>
<dl>
<dt>Vorgabewert</dt>
<dd>Vorgabewert nur bei Werttyp &quot;Auswahlliste&quot; definierbar</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Vorgabewerts</dd>
<dt>Anzahl</dt>
<dd>Zeigt die Anzahl Personen welche diesen Vorgabewert zugeordnet haben.</dd>
</dl>
<h2 id="datenfelder-sprachversionen" tabindex="-1"><a class="header-anchor" href="#datenfelder-sprachversionen"><span>Datenfelder (Sprachversionen)</span></a></h2>
<dl>
<dt>Wert</dt>
<dd>Bezeichnung der Sprachvariante.</dd>
<dt>Sprache</dt>
<dd>Auswahl der Sprache</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>zu Ad-Hoc Selektion hinzufügen</dt>
<dd>Fügt alle Adressen mit diesem Merkmal zur Ad-Hoc Selektion hinzu</dd>
<dt>Drucken...</dt>
<dd>Druckt die Merkmal-Liste aus.</dd>
<dt>Merkmale, mit Auswahlliste Drucken...</dt>
<dd>Druckt die Merkmale mit der Auswahlliste zusammen aus.</dd>
</dl>
</div></template>


